import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import { showPopupModal } from "@widgets/CommonModal";
import SN_SAL_ISU_REG_002_POP_001 from "@menu/SAL/SN_SAL_ISU_REG_002/SN_SAL_ISU_REG_002_POP_001";
import SnButton from "@shared/components/SnButton";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

// 출하반품의뢰등록
const SN_SAL_ISU_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const gridApiRefL = useRef<any>(null); // 두 번째  그리드 Reference 변수
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [columns2, setColums2] = useState<any[]>([]); // gridApiRefL 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRefH datasource 관련
  const [dataSource2, setDataSource2] = useState<any>(); // gridApiRefL datasource 관련
  const [isLoading, setIsLoading] = useState(false);
  const [grid1Focus, setGrid1Focus] = useState(false);
  const [grid2Focus, setGrid2Focus] = useState(false);
  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_SAL_ISU_REG_002";
  const defaultSize = {
    panel1height: "45.5%",
    panel2height: "45.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  //#endregion

  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedDtDocu, setSelectedDtDocu] = useState<string>("");

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums1(rtn.grid.grid1); // H그리드 항목 설정
        setColums2(rtn.grid.grid2); // L그리드 항목 설정
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (grid1Focus) {
      gridApiRefH.current.selectAndFocusRow(0);
      setGrid1Focus(false);
    }
    if (grid2Focus) {
      gridApiRefL.current.selectAndFocusRow(0);
      setGrid2Focus(false);
    }
  }, [grid1Focus, grid2Focus]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridApiRefH.current.getChange();
    const modifiedRowsL = gridApiRefL.current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const param = {
        id: "sn_sal_isu_reg_002_01",
        params: searchRef.current.getFormdata(),
      };
      setDataSource1([]);
      setDataSource2([]);
      const data: any = await fnGetDataSet(param);
      setDataSource1(data[0]);
      setDataSource2(data[1] || []);

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)
        setGrid1Focus(true);
        setGrid2Focus(true);
      }
      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = async () => {
    try {
      const newRow = {}; // 빈 객체
      gridApiRefH.current?.addRow(newRow);
      setTimeout(() => {
        gridApiRefH.current.api.setFocusedCell(
          gridApiRefH.current.api.getDisplayedRowCount() - 1,
          "cd_cust"
        );
      }, 50);
    } catch (error: any) {}
  };

  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const salIsureqhChanges = gridApiRefH.current.getChange().insert;
      //const selectedRows = gridApiRefH.current.api.getSelectedNodes();
      const selectedFormData = searchRef.current.getFormdata();
      if (salIsureqhChanges.length > 0) return false;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_biz_isu: userInfo.cd_biz,
        no_req: "",
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_req: todayform,
        cd_cust_dlv: "",
        fg_trns: selectedFormData.fg_trns ?? "1",
        cd_exch: "000",
        rt_exch: 1,
        cd_gp: userInfo.cd_gp,
        cd_io: "230",
        fg_io: "2",
        fg_money: "1",
        yn_autoprocess: "N",
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        no_hst: 0,
        qt_dummy01: 0,
        qt_dummy02: 0,
        dc_item_unit: 0,
        cd_item_spec: 0,
        //cd_io:_cdio,
        st_req: "F",
        nm_cust: selectedFormData.nm_cust ?? "",
        nm_cust_sort: selectedFormData.nm_cust_sort ?? "",
        cd_cust: selectedFormData.cd_cust ?? "",
      };
      Object.assign(newRow, updatedRow); // 원본 객체 수정
      return true;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };

  const onAddRow = async () => {
    try {
      const newRow = {}; // 빈 객체
      gridApiRefL.current?.addRow(newRow);
      setTimeout(() => {
        gridApiRefL.current.api.setFocusedCell(
          gridApiRefL.current.api.getDisplayedRowCount() - 1,
          "cd_item"
        );
      }, 50);
    } catch (error: any) {}
  };

  const onBeforeAddRowL = (newRow: RowData): boolean => {
    try {
      if (
        !gridApiRefH ||
        gridApiRefH.current.api.getSelectedNodes().length === 0
      ) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }
      const allRowData: any[] = [];
      gridApiRefL.current.api.forEachNode((node: any) => {
        allRowData.push(node.data);
      });

      const selectedRows = gridApiRefH.current.api.getSelectedNodes();
      const selectedFormData = searchRef.current.getFormdata();

      const maxNoLine =
        allRowData.length > 0
          ? Math.max(...allRowData.map((row: any) => row.no_line || 0))
          : 0;
      const rowCount = gridApiRefL.current.api.getDisplayedRowCount();

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_req: selectedRows[0].data?.no_req,
        no_line: rowCount + 1,
        no_line_so: rowCount + 1,
        no_line_isu_src: rowCount + 1,
        st_req: "F",
        yn_protect: "N",
        no_line_lc: "0",
        rt_exch: 1,
        fg_vat: "",
        dt_dlv: todayform,
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        no_hst: 0,
        qt_dummy01: 0,
        qt_dummy02: 0,
      };
      const selectedNode = gridApiRefH.current.api.getSelectedNodes()[0];
      const fgTrns = String(selectedNode.data?.fg_trns || "");

      switch (fgTrns) {
        case "1":
          updatedRow.fg_vat = "11";
          break;

        case "2":
        case "3":
          updatedRow.fg_vat = "14";
          break;

        case "4":
        case "5":
          updatedRow.fg_vat = "15";
          break;
      }
      Object.assign(newRow, updatedRow); // 원본 객체 수정
      return true;
    } catch (error: any) {
      return false; // cd_cust 값이 없는 행이 있으면 종료
    }
  };

  const onDelete = async () => {
    if (gridApiRefH.current?.api.getDisplayedRowCount() === 0) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return; // 사용자가 아니오를 선택하면 함수 종료
    }

    gridApiRefL.current?.deleteAllRows();
    gridApiRefH.current?.deleteSelectedRows();

    const realDeletedRows = gridApiRefH.current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
      return;
    }
    await onSave();
  };

  const onDeleteRow = async () => {
    gridApiRefL.current?.deleteSelectedRows();
    await gridApiRefL.current.getFooterDataAsync();
    const footerData = gridApiRefL.current.footer;
    const gridApiH = gridApiRefH.current.api;
    await setFooterDataToRow(gridApiH, footerData);
  };

  const onSave = async () => {
    try {
      gridApiRefH.current.api.stopEditing();
      gridApiRefL.current.api.stopEditing();
      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      const requiredValuesCheckL = gridApiRefL.current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      const salIsureqhChanges = gridApiRefH.current.getChange();
      const salIsureqlChanges = gridApiRefL.current.getChange();
      const headerInserts = salIsureqhChanges.insert ?? [];
      const lineInserts = salIsureqlChanges.insert ?? [];

      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return;
      }
      if (
        salIsureqhChanges.modifiedRowcount === 0 &&
        salIsureqlChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      //신규 등록된 수주건이 있는 경우 채번
      for (let row of headerInserts) {
        if (!row.no_req) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            // getNoSlip 호출
            const no_slip = await getNoSlip(
              cd_module,
              8,
              "IRT",
              row.dt_req,
              cd_menu
            );
            if (no_slip) {
              row.no_req = no_slip;

              const gridApiH = gridApiRefH.current.api;
              const focusedCell = gridApiH.getFocusedCell();

              if (focusedCell) {
                const rowNode = gridApiH.getDisplayedRowAtIndex(
                  focusedCell.rowIndex
                );
                rowNode.setDataValue("no_req", no_slip);
              } else {
                const rowNode = gridApiH.getDisplayedRowAtIndex(
                  focusedCell.rowIndex
                );
                rowNode.setDataValue("am_supply", no_slip);
              }

              for (let row of lineInserts) {
                if (!row.no_req) {
                  if (no_slip) {
                    row.no_req = no_slip;
                  }
                }
              }
              gridApiRefL.current.applyFilters({ no_req: no_slip });
            }
          } catch (error) {}
        }
      }
      // 요청 데이터 구성
      const SaveData = {
        sal_isureqh: salIsureqhChanges,
        sal_isureql: salIsureqlChanges,
      };
      if (
        (!SaveData.sal_isureqh ||
          SaveData.sal_isureqh.modifiedRowcount === 0) &&
        (!SaveData.sal_isureql || SaveData.sal_isureql.modifiedRowcount === 0)
      ) {
        await showDialog("error", "변경된 내용이 없습니다.");
        return;
      }
      // 저장 API 호출
      await fnSave("SN_SAL_ISU_REG_002_SAVE_01", SaveData);
      // 성공적으로 저장된 후 초기화
      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {}
  };
  //#endregion

  //#region  Event Method
  const onButtonClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }
    if (id === "deleteRow") {
      onDeleteRow();
    }

    if (id == "aButton_app") {
      // 신규행이 없으면 Dialog로 띄우기
      const salIsureqhChanges = gridApiRefH.current.getChange().insert;
      if (salIsureqhChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      // searchPanel에서 선택된 값 전달
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
        cd_cust: selectedFormData.cd_cust,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
      };

      const component = (
        <SN_SAL_ISU_REG_002_POP_001 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "출하적용",
        children: component,
        width: "70%",
        height: "98%",
      });
      if (!result || result === "close") return;
      const headerResult = result[0];
      const lineResult: any[] = result[1];

      // 견적도움창 Header 결과 적용
      const focusedCellH = gridApiRefH.current.api.getFocusedCell();
      if (focusedCellH) {
        const rowNode = gridApiRefH.current.api.getDisplayedRowAtIndex(
          focusedCellH.rowIndex
        );
        if (headerResult[0]) {
          headerResult[0].cd_biz &&
            gridApiRefH.current.setValue(
              rowNode,
              "cd_biz",
              headerResult[0].cd_biz
            );
          headerResult[0].dt_sales &&
            gridApiRefH.current.setValue(rowNode, "dt_sales", todayform);
          headerResult[0].cd_cust &&
            gridApiRefH.current.setValue(
              rowNode,
              "cd_cust",
              headerResult[0].cd_cust
            );
          headerResult[0].nm_cust &&
            gridApiRefH.current.setValue(
              rowNode,
              "nm_cust",
              headerResult[0].nm_cust
            );
          headerResult[0].nm_cust_sort &&
            gridApiRefH.current.setValue(
              rowNode,
              "nm_cust_sort",
              headerResult[0].nm_cust_sort
            );
          headerResult[0].fg_trns &&
            gridApiRefH.current.setValue(
              rowNode,
              "fg_trns",
              headerResult[0].fg_trns
            );
          headerResult[0].am_supply &&
            gridApiRefH.current.setValue(
              rowNode,
              "am_supply",
              headerResult[0].am_supply
            );
          headerResult[0].cd_exch &&
            gridApiRefH.current.setValue(
              rowNode,
              "cd_exch",
              headerResult[0].cd_exch
            );
          headerResult[0].cd_dept &&
            gridApiRefH.current.setValue(rowNode, "cd_dept", userInfo.cd_dept);
          headerResult[0].cd_emp &&
            gridApiRefH.current.setValue(rowNode, "cd_emp", userInfo.cd_emp);
          headerResult[0].nm_emp &&
            gridApiRefH.current.setValue(rowNode, "nm_emp", userInfo.nm_emp);
          headerResult[0].cd_gp &&
            gridApiRefH.current.setValue(
              rowNode,
              "cd_gp",
              headerResult[0].cd_gp
            );
        }
      }

      // 견적도움창 Line 결과 적용
      lineResult.map((result: any) => {
        if (headerResult[0]) {
          onAddRow();
          const rowCount = gridApiRefL.current.api.getDisplayedRowCount();
          const lastRowIndex = rowCount - 1;

          // 마지막 행에 대한 rowNode를 가져오기
          const lastRowNode =
            gridApiRefL.current.api.getDisplayedRowAtIndex(lastRowIndex);

          if (lastRowNode) {
            // 추가된 행에 값을 설정
            gridApiRefL.current.setValue(lastRowNode, "fg_vat", result.fg_vat);
            gridApiRefL.current.setValue(
              lastRowNode,
              "rt_exch",
              result.rt_exch
            );
            gridApiRefL.current.setValue(lastRowNode, "no_io", result.no_io);
            gridApiRefL.current.setValue(lastRowNode, "no_so", result.no_order);
            gridApiRefL.current.setValue(
              lastRowNode,
              "no_line_so",
              result.no_line_order
            );

            gridApiRefL.current.setValue(
              lastRowNode,
              "no_isu_src",
              result.no_io
            );
            gridApiRefL.current.setValue(
              lastRowNode,
              "no_line_ius_src",
              result.no_line
            );
            gridApiRefL.current.setValue(lastRowNode, "dt_io", result.dt_io);
            gridApiRefL.current.setValue(
              lastRowNode,
              "cd_item",
              result.cd_item
            );
            gridApiRefL.current.setValue(
              lastRowNode,
              "nm_item",
              result.nm_item
            );

            gridApiRefL.current.setValue(
              lastRowNode,
              "dc_item_spec",
              result.dc_item_spec
            );
            gridApiRefL.current.setValue(
              lastRowNode,
              "dc_item_unit",
              result.dc_item_unit
            );
            gridApiRefL.current.setValue(lastRowNode, "um", result.um);
            gridApiRefL.current.setValue(lastRowNode, "um_k", result.um_k);
            gridApiRefL.current.setValue(lastRowNode, "am", result.am);

            gridApiRefL.current.setValue(lastRowNode, "am_k", result.am_k);
            gridApiRefL.current.setValue(lastRowNode, "am_vat", result.am_vat);
            gridApiRefL.current.setValue(
              lastRowNode,
              "um_supply",
              result.um_supply
            );
            gridApiRefL.current.setValue(
              lastRowNode,
              "am_supply",
              result.am_supply
            );
            gridApiRefL.current.setValue(lastRowNode, "qt", result.qt_app);

            gridApiRefL.current.setValue(lastRowNode, "cd_pjt", result.cd_pjt);
            gridApiRefL.current.setValue(lastRowNode, "fg_io", result.fg_io);
            gridApiRefL.current.setValue(lastRowNode, "dc_rmk", result.dc_rmk);
            gridApiRefL.current.setValue(lastRowNode, "cd_wh", result.cd_wh);
            gridApiRefL.current.setValue(lastRowNode, "nm_wh", result.nm_wh);
          }
        }
      });
    }
  };
  //#endregion

  //#region Event Method
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const no_req = selectedRow.no_req;
      const dt_req = selectedRow.dt_req || "";
      gridApiRefL.current.applyFilters({ no_req });
      setGrid2Focus(true);
      setSelectedDocu(no_req);
      setSelectedDtDocu(dt_req);
    } else {
      return;
    }
  };

  // 계산식 함수
  const calculateAmounts = (row: any, updatedColumnId?: string) => {
    const qt = row.qt ?? 0;
    const um = row.um ?? 0;
    const am = row.am ?? 0;
    const am_k = row.am_k ?? 0;
    const am_vat = row.am_vat ?? 0;

    if (updatedColumnId === "qt" || updatedColumnId === "um") {
      row.am = qt * um;
      row.am_k = row.am;
      row.am_vat = row.am * 0.1;
    } else if (updatedColumnId === "am") {
      row.am_k = am;
      row.am_vat = am * 0.1;
    } else if (updatedColumnId === "am_k") {
      row.am = am_k;
      row.am_vat = am_k * 0.1;
    } else if (updatedColumnId === "am_vat") {
      row.am_vat = am_k * 0.1;
    }
  };

  const onCellValueChangedH = async (event: any) => {
    if (!event) return;
    const gridApiH = gridApiRefH.current.api;
    if (gridApiH) {
      const selectedDataH = gridApiH.getSelectedRows();
      if (selectedDataH.length > 0) {
        selectedDataH.forEach((row: any) => {
          if (row.cd_cust !== row._previousCdCust) {
            row.cd_cust_dlv = row.cd_cust; // cd_cust_dlv에 값을 넣음
          }
        });
      }
    }
  };

  const onCellValueChanged = async (event: any) => {
    if (!event) return;

    const updatedRow = event.data;

    // 수정된 컬럼 ID 및 정보
    const updatedColumnId = event.column.getColId(); // 수정된 컬럼의 ID
    const updatedColumnDef = event.colDef; // 수정된 컬럼의 정의

    if (updatedColumnId === "qt" || updatedColumnId === "um") {
      calculateAmounts(updatedRow, updatedColumnId);
    }

    calculateAmounts(updatedRow, updatedColumnId);

    // gridApiRefL에서 footerData 가져오기
    await gridApiRefL.current.getFooterDataAsync();
    const footerData = gridApiRefL.current.footer;

    const gridApiH = gridApiRefH.current.api;
    await setFooterDataToRow(gridApiH, footerData);
  };

  // footer에 집계된 내용 상단 그리드에 적용
  const setFooterDataToRow = async (gridApi: any, footerData: any) => {
    const focusedCell = gridApi.getFocusedCell();

    if (focusedCell) {
      const rowNode = gridApi.getDisplayedRowAtIndex(focusedCell.rowIndex);
      rowNode.setDataValue("am", footerData.am ?? 0);
      rowNode.setDataValue("am_k", footerData.am_k ?? 0);
      rowNode.setDataValue("am_vat", footerData.am_vat ?? 0);
      rowNode.setDataValue("am_supply", footerData.am_supply ?? 0);
    }
  };
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            // Pros로 받은 Menuprops
            seq={1} // Grid Seqno 우클릭 메뉴용
            ref={gridApiRefH} // Grid Name
            columnConfig={columns1} // 컬럼 설정 전달
            rowData={dataSource1} // Datasource
            isEditable={true} // 수정 가능여부
            rowSelection="single" // 로우 선택 모드 (단일)
            onBeforeAddRow={onBeforeAddRowH} // 행추가 전 유효성 체크 및 초기값 설정
            onFocusedRowChanged={onFocusedRowChanged}
            onCellValueChanged={onCellValueChangedH}
            title="반품정보"
            header={
              <div>
                <SnButton
                  text={"출하적용"}
                  onClick={() => {
                    onButtonClick("aButton_app");
                    onButtonClick("deleteRow");
                  }}
                />
              </div>
            }
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            // Pros로 받은 Menuprops
            seq={2} // Grid Seqno 우클릭 메뉴용
            ref={gridApiRefL} // Grid Name
            columnConfig={columns2} // 컬럼 설정 전달
            rowData={dataSource2} // Datasource
            enableExternalChart={false} // 하단 기본 차트 생성 여부
            //chartColumns={["qt", "am"]} // 차트 생성 기준 칼럼 설정
            isEditable={true} // 수정 가능여부
            rowSelection="single" // 로우 선택 모드(멀티)
            onBeforeAddRow={onBeforeAddRowL}
            onCellValueChanged={onCellValueChanged}
            title="상세정보" // 그리드 타이틀 정보
            onBtnAddClick={onButtonClick}
            onBtnDeleteClick={onButtonClick}
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={0}
          selectedDtDocu={selectedDtDocu}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_SAL_ISU_REG_002;
